import { ReactNode } from 'react'
import "../styles/hmvmChrome.css"
import { Link } from 'react-router-dom'

import { LanguageToggle } from "./LanguageToggle"
import { useLocale } from "../contexts/LocaleContext"
import { useReviewSession } from "../contexts/ReviewSessionContext"
import { AUTH_HOME } from "../lib/hmvmAuth"

function SessionNav() {
  const { t } = useLocale()
  const { session, logout } = useReviewSession()

  if (!session?.name) {
    return (
      <a href={AUTH_HOME} title={t("common.sso")}>
        {t("common.sso")}
      </a>
    )
  }

  const method = session.auth_via === 'tg' ? 'TG' : 'SSO'
  return (
    <div className="hmvm-session" data-testid="hmvm-session">
      <span className="hmvm-session-id" title={session.sub || session.name}>
        {session.name}
        <span className="hmvm-lang-sep" aria-hidden="true">
          |
        </span>
        <span className="hmvm-session-method">{method}</span>
      </span>
      <button
        type="button"
        className="hmvm-logout"
        onClick={() => void logout()}
        aria-label={t("common.logout")}
      >
        {t("common.logout")}
      </button>
    </div>
  )
}

export function HmvmHeader({ right }: { right?: ReactNode }) {
  const { t } = useLocale()
  return (
    <header className="hmvm-top" data-testid="hmvm-header">
      <a className="hmvm-auth-home" href={AUTH_HOME} title={t("common.authHome")}>
        <span className="hmvm-mark hmvm-mark--auth" aria-hidden="true">
          &lt;
        </span>
        <span>Auth</span>
      </a>
      <Link className="hmvm-brand" to="/" data-testid="hmvm-brand">
        <span className="hmvm-mark hmvm-mark--review" aria-hidden="true">
          RV
        </span>
        <span>
          <strong>HMVM</strong>Reviewer
        </span>
      </Link>
      <nav className="hmvm-top-nav">
        <LanguageToggle />
        {right ?? <SessionNav />}
      </nav>
    </header>
  )
}

export function HmvmFooter() {
  return (
    <footer className="hmvm-foot" data-testid="hmvm-footer">
      <span>
        © {new Date().getFullYear()} <a href="https://hmvm.ru">HMVM</a> · review.hmvm.ru
      </span>
    </footer>
  )
}
